import { SelectMediaCategoryType } from '@wix/editor-platform-sdk-types';

export function convertMediaCategory(
  originalCategory?: SelectMediaCategoryType | string,
): string | undefined {
  if (!originalCategory) {
    return undefined;
  }

  switch (originalCategory) {
    case 'UNKNOWN_CategoryName':
      return 'IMAGE';

    case 'UNKNOWN_VideoCategoryTypes':
      return 'VIDEO';

    case 'UNKNOWN_VectorArtCategoryTypes':
      return 'VECTOR_ART';

    default:
      return originalCategory;
  }
}
